import React from "react";
import { Logo } from "assets/svg";
import { Link } from "react-router-dom";

const EmailSent: React.FC = () => {
  return (
    <main className="bg--blur box">
      <div
        className="w-full relative rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          メールを送信しました
        </h2>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[10px]">
          ご入力いただいたメールアドレス宛に <br />
          本登録用のリンクを送信しました。
        </p>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[15px]">
          メールの受信ボックスをご確認ください。
        </p>
        <p className="text-[11px] sm:text-[12px] font-normal leading-[160%] text-center mb-[30px]">
          ※数分たっても届かない場合は、
          <br className="sm:hidden" />
          迷惑メールフォルダをご確認ください。
        </p>

        <Link
          to={"/"}
          className="w-full py-[10px] px-[20px] font-bold bg-primary text-white rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px] text-center"
        >
          トップに戻る
        </Link>
      </div>
    </main>
  );
};

export default EmailSent;
